import { IsNotEmpty, IsString } from 'class-validator';

export class PersonValidateCodeRequest {
    @IsString()
    @IsNotEmpty()
    public readonly code: string;

    constructor(data?: Partial<PersonValidateCodeRequest>) {
        this.code = data?.code;
    }
}
